var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0866 1.86624C14.5656 2.09771 14.0048 2.25359 13.4167 2.32398C14.0171 1.96402 14.4782 1.39432 14.695 0.715502C14.1338 1.04901 13.5107 1.2904 12.8489 1.42125C12.3184 0.856275 11.5621 0.50293 10.7265 0.50293C9.12083 0.50293 7.81893 1.80483 7.81893 3.41047C7.81893 3.63816 7.84492 3.86018 7.89452 4.07322C5.47779 3.95229 3.33552 2.79447 1.90135 1.03531C1.65099 1.46471 1.50785 1.96402 1.50785 2.49688C1.50785 3.50542 2.02039 4.3954 2.80125 4.91691C2.32414 4.90179 1.87631 4.77094 1.48376 4.55317V4.58954C1.48376 5.99867 2.48664 7.1735 3.81593 7.44134C3.57218 7.50747 3.3152 7.54338 3.05019 7.54338C2.86266 7.54338 2.68031 7.52495 2.5027 7.49094C2.87258 8.64592 3.94678 9.48678 5.21892 9.51039C4.22407 10.2898 2.97036 10.7551 1.608 10.7551C1.37275 10.7551 1.14128 10.7414 0.914062 10.714C2.20084 11.5388 3.72901 12.0207 5.37103 12.0207C10.7189 12.0207 13.6435 7.59014 13.6435 3.74822C13.6435 3.62209 13.6411 3.49644 13.635 3.37221C14.2037 2.96123 14.6969 2.44916 15.0866 1.86624Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.290937e50698e3003f4596dfe40512e3.svg";
export { ForwardRef as ReactComponent };